import React, { useState } from 'react';
import { ClockIcon, MailIcon, MenuIcon, PhoneIcon, XIcon, CheckIcon } from 'lucide-react';
// Special header for the Tax page that links back to main site
function TaxPageHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <header className="bg-[#8A9A5B] shadow-sm sticky top-0 z-50" data-id="element-427">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-428">
        <div className="flex justify-between items-center py-4" data-id="element-429">
          <div className="flex items-center" data-id="element-430">
            <a href="https://meyerbkt.com" data-id="element-431">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mhSQzqAkdBcNMQ8aCTM7Tt/Gray_Logo.png" alt="Meyer Bookkeeping & Tax Logo" className="h-12 w-auto" data-id="element-432" />
            </a>
          </div>
          {/* Desktop navigation */}
          <nav className="hidden md:flex space-x-8" data-id="element-433">
            <a href="https://meyerbkt.com/#services" className="text-white hover:text-gray-200 text-sm font-medium" data-id="element-434">
              Services
            </a>
            <a href="https://meyerbkt.com/#process" className="text-white hover:text-gray-200 text-sm font-medium" data-id="element-435">
              Process
            </a>
            <a href="https://meyerbkt.com/#testimonials" className="text-white hover:text-gray-200 text-sm font-medium" data-id="element-436">
              Testimonials
            </a>
            <a href="https://meyerbkt.com/#about" className="text-white hover:text-gray-200 text-sm font-medium" data-id="element-437">
              About
            </a>
            <a href="https://meyerbkt.com/#faq" className="text-white hover:text-gray-200 text-sm font-medium" data-id="element-438">
              FAQ
            </a>
            <a href="https://meyerbkt.com/contact" className="bg-[#3A4A46] text-white px-4 py-2 rounded hover:bg-opacity-80 transition-colors" data-id="element-439">
              Book a Call
            </a>
          </nav>
          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-440">
            <button onClick={toggleMenu} className="text-white hover:text-gray-200 focus:outline-none" data-id="element-441">
              {isMenuOpen ? <XIcon className="h-6 w-6" data-id="element-442" /> : <MenuIcon className="h-6 w-6" data-id="element-443" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden bg-[#9BAB6C] border-t border-[#79894A]" data-id="element-444">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-445">
            <a href="https://meyerbkt.com/#services" className="block px-3 py-2 text-base font-medium text-white hover:bg-[#79894A]" onClick={() => setIsMenuOpen(false)} data-id="element-446">
              Services
            </a>
            <a href="https://meyerbkt.com/#process" className="block px-3 py-2 text-base font-medium text-white hover:bg-[#79894A]" onClick={() => setIsMenuOpen(false)} data-id="element-447">
              Process
            </a>
            <a href="https://meyerbkt.com/#testimonials" className="block px-3 py-2 text-base font-medium text-white hover:bg-[#79894A]" onClick={() => setIsMenuOpen(false)} data-id="element-448">
              Testimonials
            </a>
            <a href="https://meyerbkt.com/#about" className="block px-3 py-2 text-base font-medium text-white hover:bg-[#79894A]" onClick={() => setIsMenuOpen(false)} data-id="element-449">
              About
            </a>
            <a href="https://meyerbkt.com/#faq" className="block px-3 py-2 text-base font-medium text-white hover:bg-[#79894A]" onClick={() => setIsMenuOpen(false)} data-id="element-450">
              FAQ
            </a>
            <a href="https://meyerbkt.com/contact" className="block px-3 py-2 text-base font-medium bg-[#3A4A46] text-white rounded" onClick={() => setIsMenuOpen(false)} data-id="element-451">
              Book a Call
            </a>
          </div>
        </div>}
    </header>;
}
// Special footer for the Tax page that links back to main site
function TaxPageFooter() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-gray-900 text-white py-8" data-id="element-452">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-453">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-454">
          <div className="mb-4 md:mb-0" data-id="element-455">
            <a href="https://meyerbkt.com" data-id="element-456">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ftirAgMM8xqTRnsAszCk3U/New_Logo.png" alt="Meyer Bookkeeping & Tax Logo" className="h-10 w-auto" data-id="element-457" />
            </a>
          </div>
          <div className="flex flex-col md:flex-row md:space-x-8 text-center md:text-left" data-id="element-458">
            <a href="https://meyerbkt.com/#services" className="text-gray-300 hover:text-white mb-2 md:mb-0" data-id="element-459">
              Services
            </a>
            <a href="https://meyerbkt.com/#process" className="text-gray-300 hover:text-white mb-2 md:mb-0" data-id="element-460">
              Process
            </a>
            <a href="https://meyerbkt.com/#testimonials" className="text-gray-300 hover:text-white mb-2 md:mb-0" data-id="element-461">
              Testimonials
            </a>
            <a href="https://meyerbkt.com/#about" className="text-gray-300 hover:text-white mb-2 md:mb-0" data-id="element-462">
              About
            </a>
            <a href="https://meyerbkt.com/#faq" className="text-gray-300 hover:text-white mb-2 md:mb-0" data-id="element-463">
              FAQ
            </a>
            <a href="https://meyerbkt.com/contact" className="text-gray-300 hover:text-white" data-id="element-464">
              Contact
            </a>
          </div>
        </div>
        <div className="pt-6 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center" data-id="element-465">
          <p className="text-gray-400 text-sm" data-id="element-466">
            &copy; {currentYear} Meyer Bookkeeping & Tax. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0 flex items-center" data-id="element-467">
            <div className="flex space-x-4 items-center" data-id="element-468">
              <a href="https://www.facebook.com/profile.php?id=61578990285219" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white" data-id="element-469">
                <span className="sr-only" data-id="element-470">Facebook</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-471">
                  <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" data-id="element-472" />
                </svg>
              </a>
              <a href="https://www.instagram.com/meyerbookkeeping/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white" data-id="element-473">
                <span className="sr-only" data-id="element-474">Instagram</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-475">
                  <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" data-id="element-476" />
                </svg>
              </a>
              <a href="https://www.linkedin.com/company/meyer-bookkeeping-tax/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white" data-id="element-477">
                <span className="sr-only" data-id="element-478">LinkedIn</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-479">
                  <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd" data-id="element-480" />
                </svg>
              </a>
              <a href="https://www.bible.com/bible/111/1PE.4.NIV" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white ml-4" data-id="element-481">
                1 Peter 4:10
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}
export function TaxPreparationPage() {
  return <div className="font-sans" data-id="element-482">
      <TaxPageHeader data-id="element-483" />
      {/* Hero Section */}
      <section className="bg-[#F5F7F6] py-16" data-id="element-484">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-485">
          <div className="text-center max-w-3xl mx-auto" data-id="element-486">
            <h1 className="text-3xl md:text-4xl font-bold text-[#3A4A46] mb-6" data-id="element-487">
              Tax Preparation Services
            </h1>
            <p className="text-xl text-gray-600" data-id="element-488">
              Professional tax preparation for individuals and small businesses.
              I help you navigate the tax code, maximize deductions, and ensure
              full compliance, while taking the stress out of tax season.
            </p>
          </div>
        </div>
      </section>
      {/* Who I Serve & What's Included */}
      <section className="py-16 bg-white" data-id="element-489">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-490">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-491">
            {/* Who I Serve */}
            <div data-id="element-492">
              <h2 className="text-2xl md:text-3xl font-bold text-[#3A4A46] mb-6" data-id="element-493">
                Who I Serve
              </h2>
              <ul className="space-y-3" data-id="element-494">
                <li className="flex items-start" data-id="element-495">
                  <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0 mt-0.5" data-id="element-496">
                    •
                  </span>
                  <span className="text-gray-700" data-id="element-497">Individuals & families</span>
                </li>
                <li className="flex items-start" data-id="element-498">
                  <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0 mt-0.5" data-id="element-499">
                    •
                  </span>
                  <span className="text-gray-700" data-id="element-500">
                    Contractors / freelancers
                  </span>
                </li>
                <li className="flex items-start" data-id="element-501">
                  <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0 mt-0.5" data-id="element-502">
                    •
                  </span>
                  <span className="text-gray-700" data-id="element-503">Small businesses</span>
                </li>
                <li className="flex items-start" data-id="element-504">
                  <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0 mt-0.5" data-id="element-505">
                    •
                  </span>
                  <span className="text-gray-700" data-id="element-506">Rental property owners</span>
                </li>
              </ul>
            </div>
            {/* What's Included */}
            <div data-id="element-507">
              <h2 className="text-2xl md:text-3xl font-bold text-[#3A4A46] mb-6" data-id="element-508">
                What's Included
              </h2>
              <ul className="space-y-3" data-id="element-509">
                <li className="flex items-start" data-id="element-510">
                  <CheckIcon className="h-6 w-6 text-[#8A9A5B] mr-3 flex-shrink-0 mt-0.5" data-id="element-511" />
                  <span className="text-gray-700" data-id="element-512">
                    Personal & small business returns
                  </span>
                </li>
                <li className="flex items-start" data-id="element-513">
                  <CheckIcon className="h-6 w-6 text-[#8A9A5B] mr-3 flex-shrink-0 mt-0.5" data-id="element-514" />
                  <span className="text-gray-700" data-id="element-515">E-file included</span>
                </li>
                <li className="flex items-start" data-id="element-516">
                  <CheckIcon className="h-6 w-6 text-[#8A9A5B] mr-3 flex-shrink-0 mt-0.5" data-id="element-517" />
                  <span className="text-gray-700" data-id="element-518">Secure client portal</span>
                </li>
                <li className="flex items-start" data-id="element-519">
                  <CheckIcon className="h-6 w-6 text-[#8A9A5B] mr-3 flex-shrink-0 mt-0.5" data-id="element-520" />
                  <span className="text-gray-700" data-id="element-521">Year-round support</span>
                </li>
                <li className="flex items-start" data-id="element-522">
                  <CheckIcon className="h-6 w-6 text-[#8A9A5B] mr-3 flex-shrink-0 mt-0.5" data-id="element-523" />
                  <span className="text-gray-700" data-id="element-524">
                    Optional bookkeeping clean-up
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Pricing */}
      <section className="py-16 bg-[#F5F7F6]" data-id="element-525">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-526">
          <div className="text-center max-w-2xl mx-auto" data-id="element-527">
            <h2 className="text-2xl md:text-3xl font-bold text-[#3A4A46] mb-4" data-id="element-528">
              Pricing
            </h2>
            <p className="text-lg text-gray-700" data-id="element-529">
              Returns start at{' '}
              <span className="font-bold text-[#3A4A46]" data-id="element-530">$200</span>, with most
              clients ranging from <span className="font-bold" data-id="element-531">$275–$600</span>,
              depending on complexity.
            </p>
          </div>
        </div>
      </section>
      {/* How It Works */}
      <section className="py-16 bg-white" data-id="element-532">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-533">
          <div className="text-center mb-12" data-id="element-534">
            <h2 className="text-2xl md:text-3xl font-bold text-[#3A4A46] mb-4" data-id="element-535">
              How It Works
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-536">
            {/* Step 1 */}
            <div className="text-center" data-id="element-537">
              <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-[#3A4A46] text-white mb-4 text-2xl font-bold" data-id="element-538">
                1
              </div>
              <h3 className="text-lg font-bold text-[#3A4A46] mb-2" data-id="element-539">
                Submit the quote form
              </h3>
            </div>
            {/* Step 2 */}
            <div className="text-center" data-id="element-540">
              <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-[#3A4A46] text-white mb-4 text-2xl font-bold" data-id="element-541">
                2
              </div>
              <h3 className="text-lg font-bold text-[#3A4A46] mb-2" data-id="element-542">
                Receive your estimate
              </h3>
            </div>
            {/* Step 3 */}
            <div className="text-center" data-id="element-543">
              <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-[#3A4A46] text-white mb-4 text-2xl font-bold" data-id="element-544">
                3
              </div>
              <h3 className="text-lg font-bold text-[#3A4A46] mb-2" data-id="element-545">
                Approve & upload documents
              </h3>
            </div>
            {/* Step 4 */}
            <div className="text-center" data-id="element-546">
              <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-[#3A4A46] text-white mb-4 text-2xl font-bold" data-id="element-547">
                4
              </div>
              <h3 className="text-lg font-bold text-[#3A4A46] mb-2" data-id="element-548">
                I prepare and file your return- simple!
              </h3>
            </div>
          </div>
        </div>
      </section>
      {/* Form & Image Section */}
      <section className="bg-[#F5F7F6] py-16" data-id="element-549">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-550">
          <div className="text-center mb-8" data-id="element-551">
            <h2 className="text-2xl md:text-3xl font-bold text-[#3A4A46] mb-4" data-id="element-552">
              Get Your Tax Quote
            </h2>
            <p className="text-lg text-gray-600" data-id="element-553">
              Fill out the form below to receive a personalized quote for your
              tax preparation needs.
            </p>
          </div>
          <div className="flex flex-col md:flex-row items-center justify-center gap-12" data-id="element-554">
            <div className="md:w-1/2 max-w-lg" data-id="element-555">
              <iframe src="https://preview.mailerlite.io/forms/1833129/167250058103752482/share" style={{
              width: '100%',
              height: '500px',
              border: 'none'
            }} title="Tax Preparation Form" data-id="element-556"></iframe>
            </div>
            <div className="md:w-1/2 max-w-lg" data-id="element-557">
              <img src="https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1500&q=80" alt="Tax preparation services" className="rounded-lg shadow-lg w-full h-auto" data-id="element-558" />
            </div>
          </div>
        </div>
      </section>
      <TaxPageFooter data-id="element-559" />
    </div>;
}